var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reporting-line"},[_c('div',{staticClass:"row"},[_c('div',{class:'col-xl-' + _vm.cols[0]},[_c('div',{staticClass:"reporting__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{class:'col-xl-' + _vm.cols[1]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }